import { MessageCircle } from "lucide-react";

export const FloatingCTA = () => {
  const WHATSAPP_URL = "https://api.whatsapp.com/send?phone=15874073024&text=Hi%20Garage%20Kings!%20%F0%9F%91%91%20I%27d%20like%20a%20quote%20for%20a%20cleanout.%20What%20photos%20or%20info%20do%20you%20need%20from%20me%20to%20get%20started%3F";
  return (
    <>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-24 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-elevated hover:scale-110 transition-transform md:bottom-6"
      >
        <MessageCircle className="h-7 w-7" />
      </a>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get a fast estimate from Garage Kings YEG on WhatsApp"
        className="fixed inset-x-4 bottom-4 z-40 rounded-full bg-gold py-4 text-center font-display text-lg tracking-widest text-ink shadow-gold animate-pulse-gold lg:hidden"
      >
        GET YOUR FAST ESTIMATE
      </a>
    </>
  );
};
